import { OptionCard, StepBody, StepHeader, StepNav } from "../Hikvision/HikvisionWizardParts";



// liveViewDisabled - live view links individual Camect cameras, so it's only offered in per camera arming mode
const WizardStepCamectControlType = ({ selectedOptions, setSelectedOptions, liveViewDisabled, onNext, liveViewPermitted }) => {

    let CONTROL_TYPE_OPTIONS = [
        { key: "Control", title: "Control Camect", subtitle: "Arm & disarm the Camect from a site output" }
    ];

    if (liveViewPermitted) {
        CONTROL_TYPE_OPTIONS.push({ key: "Live view", title: "Live camera viewing", subtitle: "Stream the camera feeds" })
    }
    const toggle = (key) => {
        setSelectedOptions(prev => prev.includes(key) ? prev.filter(x => x !== key) : [...prev, key]);
    };

    const isDisabled = (key) => key === "Live view" && liveViewDisabled;

    return (
        <>
            <StepHeader title="How would you like to use the Camect?" subtitle="Choose one or both" />
            <StepBody>
                {CONTROL_TYPE_OPTIONS.map(opt => (
                    <OptionCard
                        key={opt.key}
                        title={opt.title}
                        subtitle={isDisabled(opt.key) ? "Only available when the Camect integration type is per camera arming" : opt.subtitle}
                        selected={selectedOptions.includes(opt.key) && !isDisabled(opt.key)}
                        disabled={isDisabled(opt.key)}
                        onClick={() => toggle(opt.key)}
                    />
                ))}
            </StepBody>
            <StepNav onNext={onNext} nextDisabled={selectedOptions.length === 0} />
        </>
    );
};

export default WizardStepCamectControlType;
